import React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Swal from 'sweetalert2';

const SecurityCheckTab = ({
    handleTabChange,
    securityFile,
    handleFileChange,
    fileError,
    handleSubmit,
    loading
}) => {
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            if (file.type === 'application/pdf' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/png' ||
                file.type === 'image/jpg') {
                handleFileChange({ target: { files: [file] } });
            } else {
                Swal.fire("Error", "Only PDF, JPEG, or PNG files are allowed", "error");
            }
        }
    };

    return (
        <div className="tab-pane fade show active">
            <div className="row">
                <div className="col-md-12">
                    <div className="card border-0 shadow-sm mb-4">
                        <div className="card-body">
                            <div className="text-center mb-4">
                                <DescriptionIcon className="display-4 text-primary mb-3" />
                                <h4>Security Check Document Upload</h4>
                                <p className="text-muted">
                                    Please upload the security check document (PDF, JPEG, PNG format, max 5MB)
                                </p>
                            </div>

                            <div className="mb-4">
                                <div
                                    className={`file-upload-area ${fileError ? 'border-danger' : securityFile ? 'border-success' : 'border-primary'} p-5 border-2 border-dashed rounded`}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                >
                                    <input
                                        type="file"
                                        id="securityFile"
                                        className="d-none"
                                        onChange={handleFileChange}
                                        accept=".pdf,.jpg,.jpeg,.png"
                                    />
                                    <label htmlFor="securityFile" className="cursor-pointer d-block text-center">
                                        <CloudUploadIcon className="display-4 text-muted mb-3" />
                                        <h5>Click to upload or drag and drop</h5>
                                        <p className="text-muted mb-2">
                                            PDF, JPEG, or PNG (Max 5MB)
                                        </p>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                        >
                                            Browse Files
                                        </button>
                                    </label>
                                </div>

                                {fileError && (
                                    <div className="text-danger small mt-2">{fileError}</div>
                                )}

                                {securityFile && (
                                    <div className="mt-3 p-3 bg-light rounded">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <DescriptionIcon className="text-primary me-2" />
                                                <div>
                                                    <strong>{securityFile.name}</strong>
                                                    <div className="text-muted small">
                                                        {(securityFile.size / 1024 / 1024).toFixed(2)} MB
                                                    </div>
                                                </div>
                                            </div>
                                            <span className="badge bg-success d-flex align-items-center">
                                                <CheckCircleIcon className="me-1" style={{ fontSize: '16px' }} />
                                                Uploaded
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end align-items-center mt-4">
                <button
                    type="button"
                    className="btn btn-dark btn-sm mr-3"
                    onClick={() => handleTabChange("credit")}
                    disabled={loading}
                >
                    Back
                </button>

                <div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={loading || !securityFile}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Submitting...
                            </>
                        ) : (
                            <>
                                <CheckCircleIcon className="me-2" />
                                Submit Application
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SecurityCheckTab;